import React from "react";
import { Line } from "react-chartjs-2";

const themeColor = process.env.REACT_APP_BRANDING_THEME_COLOR;

const TrendsMultiSalesGraph = ({ salesGraphData, storeValue }) => {

    const getSeriesData = (graphData, storeKey, labelsLength) => {
      const series = graphData?.store_sales?.[storeKey]?.data;
      if (Array.isArray(series)) {
        return series;
      }
      return Array(labelsLength).fill(0);
    };

    const getGraphDatasets = (graphData, selectedStore) => {
      const labelsLength = Array.isArray(graphData?.labels) ? graphData.labels.length : 0;

      var amazonMusicSalesDataset = {
        order: 1,
        data: getSeriesData(graphData, "amazon_music", labelsLength),
        label: "Amazon Music stream",
        borderColor: "#4512ff",
        backgroundColor: "#4512ff",
        tension: 0.5,
        borderWidth: 1.5,
        fill: false
      };

      var appleMusicSalesDataset = {
        order: 2,
        data: getSeriesData(graphData, "apple_music", labelsLength),
        label: "Apple Music stream",
        borderColor: "#f94c57",
        backgroundColor: "#f94c57",
        tension: 0.5,
        borderWidth: 1.5,
        fill: false
      };

      var beatportSalesDataset = {
        order: 3,
        data: getSeriesData(graphData, "beatport", labelsLength),
        label: "Beatport download",
        borderColor: "#01FF95",
        backgroundColor: "#01FF95",
        tension: 0.5,
        borderWidth: 1.5,
        fill: false
      };

      var deezerSalesDataset = {
        order: 4,
        data: getSeriesData(graphData, "deezer", labelsLength),
        label: "Deezer stream",
        borderColor: "#EF5466",
        backgroundColor: "#EF5466",
        tension: 0.5,
        borderWidth: 1.5,
        fill: false
      };

      var facebookSalesDataset = {
        order: 5,
        data: getSeriesData(graphData, "facebook", labelsLength),
        label: "Facebook stream",
        borderColor: "#4267B2",
        backgroundColor: "#4267B2",
        tension: 0.5,
        borderWidth: 1.5,
        fill: false
      };

      var instagramSalesDataset = {
        order: 6,
        data: getSeriesData(graphData, "instagram", labelsLength),
        label: "Instagram stream",
        borderColor: "#8A3AB9",
        backgroundColor: "#8A3AB9",
        tension: 0.5,
        borderWidth: 1.5,
        fill: false
      };

      var itunesSalesDataset = {
        order: 7,
        data: getSeriesData(graphData, "itunes", labelsLength),
        label: "iTunes download",
        borderColor: themeColor,
        backgroundColor: themeColor,
        tension: 0.5,
        borderWidth: 1.5,
        fill: false
      };

      var pandoraSalesDataset = {
        order: 8,
        data: getSeriesData(graphData, "pandora", labelsLength),
        label: "Pandora stream",
        borderColor: "#00A0EE",
        backgroundColor: "#00A0EE",
        tension: 0.5,
        borderWidth: 1.5,
        fill: false
      };

      var soundcloudSalesDataset = {
        order: 9,
        data: getSeriesData(graphData, "soundcloud", labelsLength),
        label: "Soundcloud stream",
        borderColor: "#FF8800",
        backgroundColor: "#FF8800",
        tension: 0.5,
        borderWidth: 1.5,
        fill: false
      };

      var spotifySalesDataset = {
        order: 10,
        data: getSeriesData(graphData, "spotify", labelsLength),
        label: "Spotify stream",
        borderColor: "#2b9e62",
        backgroundColor: "#2b9e62",
        tension: 0.5,
        borderWidth: 1.5,
        fill: false
      };

      var tiktokSalesDataset = {
        order: 11,
        data: getSeriesData(graphData, "tiktok", labelsLength),
        label: "Tiktok stream",
        borderColor: "#25F4EE",
        backgroundColor: "#25F4EE",
        tension: 0.5,
        borderWidth: 1.5,
        fill: false
      };

      var traxsourceSalesDataset = {
        order: 12,
        data: getSeriesData(graphData, "traxsource", labelsLength),
        label: "Traxsource download",
        borderColor: "#40A0FF",
        backgroundColor: "#40A0FF",
        tension: 0.5,
        borderWidth: 1.5,
        fill: false
      };

      var youtubeSalesDataset = {
        order: 13,
        data: getSeriesData(graphData, "youtube", labelsLength),
        label: "Youtube stream",
        borderColor: "#FF0000",
        backgroundColor: "#FF0000",
        tension: 0.5,
        borderWidth: 1.5,
        fill: false
      };

      var youtubePremiumSalesDataset = {
        order: 14,
        data: getSeriesData(graphData, "youtube_premium", labelsLength),
        label: "Youtube Premium stream",
        borderColor: "#282828",
        backgroundColor: "#282828",
        tension: 0.5,
        borderWidth: 1.5,
        fill: false
      };


      var combinedSalesDataset = {
        order: 15,
        data: Array.isArray(graphData?.combined_sales?.data)
          ? graphData.combined_sales.data
          : Array(labelsLength).fill(0),
        label: "Total sales",
        pointBackgroundColor: "$skin1",
        borderColor: "$skin1",
        backgroundColor: "rgba(232,244,251, 0.5)",
        hoverBackgroundColor: "rgba(232,244,251, .6)",
        type: 'bar',
        fill: false
      };

      var datasets = [];

      if(selectedStore === "0")
      {
        datasets = [
          amazonMusicSalesDataset,
          appleMusicSalesDataset,
          beatportSalesDataset,
          deezerSalesDataset,
          facebookSalesDataset,
          instagramSalesDataset,
          itunesSalesDataset,
          pandoraSalesDataset,
          soundcloudSalesDataset,
          spotifySalesDataset,
          tiktokSalesDataset,
          traxsourceSalesDataset,
          youtubeSalesDataset,
          youtubePremiumSalesDataset,
          combinedSalesDataset
        ];
      }

      if(selectedStore === "ds")
      {
        datasets = [
          beatportSalesDataset,
          itunesSalesDataset,
          traxsourceSalesDataset,
          combinedSalesDataset
        ];
      }

      if(selectedStore === "ss")
      {
        datasets = [
          amazonMusicSalesDataset,
          appleMusicSalesDataset,
          deezerSalesDataset,
          facebookSalesDataset,
          instagramSalesDataset,
          pandoraSalesDataset,
          soundcloudSalesDataset,
          spotifySalesDataset,
          tiktokSalesDataset,
          youtubeSalesDataset,
          youtubePremiumSalesDataset,
          combinedSalesDataset
        ];
      }

      if(selectedStore === "am")
      {
        datasets = [amazonMusicSalesDataset, combinedSalesDataset];
      }

      if(selectedStore === "apm")
      {
        datasets = [appleMusicSalesDataset, combinedSalesDataset];
      }

      if(selectedStore === "bp")
      {
        datasets = [beatportSalesDataset, combinedSalesDataset];
      }

      if(selectedStore === "dr")
      {
        datasets = [deezerSalesDataset, combinedSalesDataset];
      }

      if(selectedStore === "fb")
      {
        datasets = [facebookSalesDataset, combinedSalesDataset];
      }

      if(selectedStore === "ig")
      {
        datasets = [instagramSalesDataset, combinedSalesDataset];
      }

      if(selectedStore === "it")
      {
        datasets = [itunesSalesDataset, combinedSalesDataset];
      }

      if(selectedStore === "pd")
      {
        datasets = [pandoraSalesDataset, combinedSalesDataset];
      }

      if(selectedStore === "sc")
      {
        datasets = [soundcloudSalesDataset, combinedSalesDataset];
      }

      if(selectedStore === "sp")
      {
        datasets = [spotifySalesDataset, combinedSalesDataset];
      }

      if(selectedStore === "tx")
      {
        datasets = [traxsourceSalesDataset, combinedSalesDataset];
      }

      if(selectedStore === "tk")
      {
        datasets = [tiktokSalesDataset, combinedSalesDataset];
      }
      
      if(selectedStore === "yt")
      {
        datasets = [youtubeSalesDataset, combinedSalesDataset];
      }
      
      if(selectedStore === "yp")
      {
        datasets = [youtubePremiumSalesDataset, combinedSalesDataset];
      }
      
      return datasets;
    };

    const options = {
        type: 'line',
        plugins: {
            legend: {
              display: true,
            },
            subtitle: {
              display: true,
              text: '* Store labels are ordered alphabetically (A-Z)'
          }
        },
        responsive: true,
        interaction: {
            mode: 'index',
            intersect: false
        },
        maintainAspectRatio: false,
        scales: {
            x: {
              grid: {
                  display: false,
                }
            },
            y: {
                grid: {
                  display: false,
                }
            }
        }
    };

  return (
    <>
      <div className="multiSalesChart">
        <Line
          width={100}
          height={500}
          data={{
            labels: Array.isArray(salesGraphData?.labels) ? salesGraphData.labels : [],
            datasets: getGraphDatasets(salesGraphData, storeValue)
          }}
          options={options}
        />
      </div>
    </>
  );
};

export default TrendsMultiSalesGraph;
